import { Route, RouteConfig } from 'vue-router';
import { WmsPageComposer } from '../components/page-composer/page-composer';
import { router } from './router';

export const IB_URL = 'iniciativa-bydleni';

export const IB_ROUTES: RouteConfig[] = [
	{
		path: '/page/iniciativa-uvod',
		name: 'iniciativa-uvod',
		meta: { ibRedirect: '/' },
		props: { pageUrl: 'iniciativa-uvod' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-formular',
		name: 'iniciativa-formular',
		alias: '/formular',
		meta: { ibRedirect: '/formular' },
		props: { pageUrl: 'iniciativa-formular' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-dostupnost',
		name: 'iniciativa-dostupnost',
		alias: '/dostupnost-bydleni',
		meta: { ibRedirect: '/dostupnost-bydleni' },
		props: { pageUrl: 'iniciativa-dostupnost' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-design-build',
		name: 'iniciativa-design-build',
		alias: '/design-build',
		meta: { ibRedirect: '/design-build' },
		props: { pageUrl: 'iniciativa-design-build' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-priprava',
		name: 'iniciativa-priprava',
		alias: '/priprava',
		meta: { ibRedirect: '/priprava' },
		props: { pageUrl: 'iniciativa-priprava' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-principy',
		name: 'iniciativa-principy',
		alias: '/principy',
		meta: { ibRedirect: '/principy' },
		props: { pageUrl: 'iniciativa-principy' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-katalog',
		name: 'iniciativa-katalog',
		alias: '/katalog',
		meta: { ibRedirect: '/katalog' },
		props: { pageUrl: 'iniciativa-katalog' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-poradenstvi',
		name: 'iniciativa-poradenstvi',
		alias: '/poradenstvi',
		meta: { ibRedirect: '/poradenstvi' },
		props: { pageUrl: 'iniciativa-poradenstvi' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-a1',
		name: 'iniciativa-typ-a1',
		alias: '/typ-a1',
		meta: { ibRedirect: '/typ-a1' },
		props: { pageUrl: 'iniciativa-typ-a1' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-a2',
		name: 'iniciativa-typ-a2',
		alias: '/typ-a2',
		meta: { ibRedirect: '/typ-a2' },
		props: { pageUrl: 'iniciativa-typ-a2' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-a3',
		name: 'iniciativa-typ-a3',
		alias: '/typ-a3',
		meta: { ibRedirect: '/typ-a3' },
		props: { pageUrl: 'iniciativa-typ-a3' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-a4',
		name: 'iniciativa-typ-a4',
		alias: '/typ-a4',
		meta: { ibRedirect: '/typ-a4' },
		props: { pageUrl: 'iniciativa-typ-a4' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-a5',
		name: 'iniciativa-typ-a5',
		alias: '/typ-a5',
		meta: { ibRedirect: '/typ-a5' },
		props: { pageUrl: 'iniciativa-typ-a5' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-a6',
		name: 'iniciativa-typ-a6',
		alias: '/typ-a6',
		meta: { ibRedirect: '/typ-a6' },
		props: { pageUrl: 'iniciativa-typ-a6' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-b1',
		name: 'iniciativa-typ-b1',
		alias: '/typ-b1',
		meta: { ibRedirect: '/typ-b1' },
		props: { pageUrl: 'iniciativa-typ-b1' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-b2',
		name: 'iniciativa-typ-b2',
		alias: '/typ-b2',
		meta: { ibRedirect: '/typ-b2' },
		props: { pageUrl: 'iniciativa-typ-b2' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-b3',
		name: 'iniciativa-typ-b3',
		alias: '/typ-b3',
		meta: { ibRedirect: '/typ-b3' },
		props: { pageUrl: 'iniciativa-typ-b3' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-b4',
		name: 'iniciativa-typ-b4',
		alias: '/typ-b4',
		meta: { ibRedirect: '/typ-b4' },
		props: { pageUrl: 'iniciativa-typ-b4' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-financovani',
		name: 'iniciativa-financovani',
		alias: '/financovani',
		meta: { ibRedirect: '/financovani' },
		props: { pageUrl: 'iniciativa-financovani' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-byty-najem',
		name: 'iniciativa-byty-najem',
		alias: '/dostupne-byty-najem',
		meta: { ibRedirect: '/dostupne-byty-najem' },
		props: { pageUrl: 'iniciativa-byty-najem' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-byty-prodej',
		name: 'iniciativa-byty-prodej',
		alias: '/dostupne-byty-prodej',
		meta: { ibRedirect: '/dostupne-byty-prodej' },
		props: { pageUrl: 'iniciativa-byty-prodej' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typy-staveb',
		name: 'iniciativa-typy-staveb',
		alias: '/typy-staveb',
		meta: { ibRedirect: '/typy-staveb' },
		props: { pageUrl: 'iniciativa-typy-staveb' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-kontakt',
		name: 'iniciativa-kontakt',
		alias: '/kontakt',
		meta: { ibRedirect: '/kontakt' },
		props: { pageUrl: 'iniciativa-kontakt' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-o-nas',
		name: 'iniciativa-o-nas',
		alias: '/o-nas',
		meta: { ibRedirect: '/o-nas' },
		props: { pageUrl: 'iniciativa-o-nas' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-byty-drustevni',
		name: 'iniciativa-byty-drustevni',
		alias: '/dostupne-drustevni-byty',
		meta: { ibRedirect: '/dostupne-drustevni-byty' },
		props: { pageUrl: 'iniciativa-byty-drustevni' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-summit',
		name: 'iniciativa-summit',
		alias: '/summit',
		meta: { ibRedirect: '/summit' },
		props: { pageUrl: 'iniciativa-summit' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-poradenstvi-financovani',
		name: 'iniciativa-poradenstvi-financovani',
		alias: '/poradenstvi-financovani',
		meta: { ibRedirect: '/poradenstvi-financovani' },
		props: { pageUrl: 'iniciativa-poradenstvi-financovani' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typove-projekty',
		name: 'iniciativa-typove-projekty',
		alias: '/typove-projekty',
		meta: { ibRedirect: '/typove-projekty' },
		props: { pageUrl: 'iniciativa-typove-projekty' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-technicke-varianty',
		name: 'iniciativa-technicke-varianty',
		alias: '/technicke-varianty',
		meta: { ibRedirect: '/technicke-varianty' },
		props: { pageUrl: 'iniciativa-technicke-varianty' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-analyza',
		name: 'iniciativa-analyza',
		alias: '/analyza',
		meta: { ibRedirect: '/analyza' },
		props: { pageUrl: 'iniciativa-analyza' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-nabidka-sluzeb',
		name: 'iniciativa-nabidka-sluzeb',
		alias: '/nabidka-sluzeb',
		meta: { ibRedirect: '/nabidka-sluzeb' },
		props: { pageUrl: 'iniciativa-nabidka-sluzeb' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-w1',
		name: 'iniciativa-typ-w1',
		alias: '/typ-w1',
		meta: { ibRedirect: '/typ-w1' },
		props: { pageUrl: 'iniciativa-typ-w1' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-w2',
		name: 'iniciativa-typ-w2',
		alias: '/typ-w2',
		meta: { ibRedirect: '/typ-w2' },
		props: { pageUrl: 'iniciativa-typ-w2' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-typ-w3',
		name: 'iniciativa-typ-w3',
		alias: '/typ-w3',
		meta: { ibRedirect: '/typ-w3' },
		props: { pageUrl: 'iniciativa-typ-w3' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-postup-vystavby',
		name: 'iniciativa-postup-vystavby',
		alias: '/postup-vystavby',
		meta: { ibRedirect: '/postup-vystavby' },
		props: { pageUrl: 'iniciativa-postup-vystavby' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-debata',
		name: 'iniciativa-debata',
		alias: '/debata',
		meta: { ibRedirect: '/debata' },
		props: { pageUrl: 'iniciativa-debata' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-registrace',
		name: 'iniciativa-registrace',
		alias: '/registrace',
		meta: { ibRedirect: '/registrace' },
		props: { pageUrl: 'iniciativa-registrace' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-registrace-2',
		name: 'iniciativa-registrace-2',
		alias: '/registrace-2',
		meta: { ibRedirect: '/registrace-2' },
		props: { pageUrl: 'iniciativa-registrace-2' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-pozvanka',
		name: 'iniciativa-pozvanka',
		alias: '/pozvanka',
		meta: { ibRedirect: '/pozvanka' },
		props: { pageUrl: 'iniciativa-pozvanka' },
		component: WmsPageComposer
	},
	{
		path: '/page/iniciativa-pozvanka-debata',
		name: 'iniciativa-pozvanka-debata',
		alias: '/pozvanka-debata',
		meta: { ibRedirect: '/pozvanka-debata' },
		props: { pageUrl: 'iniciativa-pozvanka-debata' },
		component: WmsPageComposer
	},
];

export function ibGuard(to: Route, _from: Route, next: Function): boolean {
	if (window.location.href.indexOf(IB_URL) > -1 && to.meta.ibRedirect) {
		if (to.meta.ibRedirect !== to.fullPath) {
			next({ path: to.meta.ibRedirect, replace: true });
			return true;
		}
	}

	if (window.location.href.indexOf(IB_URL) === -1 && to.meta.ibRedirect) {
		next({ path: '/nenalezeno', replace: true });
		return true;
	}

	if (
		window.location.href.indexOf(IB_URL) > -1 &&
		to.fullPath !== '/' &&
		!to.meta.ibRedirect
	) {
		const { afterClick } = (router as any).meta;

		// send all other route requets as HTTP GET requests
		if (afterClick) {
			window.location.href = to.fullPath;
		} else {
			window.location.href = `https://www.central-group.cz/nenalezeno.html`;
		}

		return true;
	}

	return false;
}
